import React from "react";
import { Grid, Typography } from "@mui/material";
import { Img } from "../../Image";
import { Button } from "../../Material";
import { Post } from "../../Confidence/LearningCenter/Post";
import { limitChars } from "../../../helpers/limitChars";
import { PostType, TagType } from "../../../types";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { useStyles } from "./Posts.styles";
import _ from "lodash"

interface PostsProps {
	posts: PostType[]
	tags: TagType[]
	discardFirstPost?: boolean
	postsNumberMobile?: number
	postsNumberDesktop?: number
	selectedTag?: TagType
	showMoreButton?: boolean
	rootClassName?: string
	containerClassName?: string
}

export function Posts({
	posts,
	tags,
	discardFirstPost,
	postsNumberMobile = 3,
	showMoreButton,
	postsNumberDesktop,
	rootClassName,
	containerClassName,
}: PostsProps) {
	const { classes, cx } = useStyles()
	const isMobile = useIsMobile('md')
	const postsNumber = isMobile ? postsNumberMobile : postsNumberDesktop || posts?.length

	const sortPosts = _.orderBy(posts, [(p: PostType) => p.publishDate], ['desc'])
		.slice(discardFirstPost ? 1 : 0, isMobile ? postsNumber + (discardFirstPost ? 1 : 0) : postsNumberDesktop)

	return (
		<section className={cx(classes.root, rootClassName)}>
			<Grid container className={cx(classes.container, containerClassName)}>
				<Grid item xs={12}>
					<Grid
						container
						spacing={isMobile ? 5 : 4}
						className={cx(classes.containerPosts, {
							[classes.emptyContainer]: posts?.length === 0,
						})}
					>
						{posts?.length === 0 ? (
							<Grid item xs={12}>
								<Grid container className={classes.emptyState}>
									<Grid item>
										<Img src="/assets/images/sin-resultado.svg" loadingType="eager" />
									</Grid>
									<Grid item>
										<Typography className={classes.emptyTitle}>Sin resultados</Typography>
									</Grid>
									<Grid item>
										<Typography className={classes.emptySubtitle}>Intenta buscando otra palabra o categoría</Typography>
									</Grid>
								</Grid>
							</Grid>
						) : sortPosts.map((post: PostType) => {
							const tag: TagType = tags.find((tag: any) => tag.id === String(post?.tagIds ? post?.tagIds[0] : 0)) || {}
							return (
								<Grid
									item
									xs={12}
									lg={4}
									className={classes.postContainer}
								>
									<Post
										post={post}
										tag={tag}
										className={classes.post}
									/>
								</Grid>
							)
						})}
					</Grid>
				</Grid>
				{(isMobile && !Boolean(showMoreButton)) && (
					<Grid item xs={12} style={{ textAlign: 'center' }}>
						<Button
							variant="contained"
							color="primary"
							className={classes.readMoreButton}
						>
							Leer más
						</Button>
					</Grid>
				)}
				{showMoreButton && (
					<Grid item xs={12} style={{ textAlign: 'center' }}>
						<Button
							to={`/blog/tag/${tags[0].name}`}
							variant="contained"
							color="primary"
							className={classes.readMoreButton}
						>
							Ver más notas
						</Button>
					</Grid>
				)}
			</Grid>
		</section>
	)
}